/**
 * @fileoverview Custom Button component wrapping MUI Button with no text
 * transformation applied by default.
 */

import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material';

export type ButtonProps = MuiButtonProps;

export function Button(props: ButtonProps) {
  const { sx, ...rest } = props;

  return (
    <MuiButton
      size="small"
      sx={{
        textTransform: 'none',
        ...sx,
      }}
      {...rest}
    />
  );
}

